module.exports = __webpack_public_path__ + "static/media/whiteDots.cb4be929.svg";